import seekLogo from '../../../assets/seek_logo.svg';
import { encodeSvg } from '../../../shared/helpers';

export const pageStyles = {
  componentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100%',
    position: 'relative',
  },
  primaryHeading: {
    marginTop: '72px',
    marginBottom: '16px',
    color: '#E60278',
    fontWeight: 400,
    fontSize: '42px',
  },
  jobTitleHeading: {
    marginBottom: '24px',
    marginTop: 0,
    color: '#0D3880',
    fontSize: '42px',
    fontWeight: 500,
  },
  secondaryHeading: {
    marginBottom: '100px',
    marginTop: 0,
    color: '#E60278',
    fontSize: '28px',
    fontWeight: 400,
  },
  QRImage: {
    width: '256px',
    height: '256px',
  },
  jobPostedDate: {
    marginTop: '24px',
    marginBottom: 0,
    color: '#0D3880',
    fontSize: '18px',
    fontWeight: 400,
  },
  logoBanner: {
    marginTop: '64px',
    marginBottom: '30px',
    height: '76px',
    display: 'flex',
    justifyContent: 'center',
    background: '#E60278',
  },
  bannerView: {
    display: 'flex',
    height: '76px',
    backgroundColor: '#E60278',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },
  logo: {
    width: '120px',
    height: '50px',
    backgroundImage: `url(${encodeSvg(seekLogo)})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    alignSelf: 'center',
  },
  logo_pdf: {
    width: '120px',
    height: '50px',
    alignSelf: 'center',
  },
};
